module.exports = __webpack_public_path__ + "media/assets/bronzeTag-c98e4ec93f09807e7729d91cef08956d.png";